// app/composables/season/phase.ts

import type { NitroFetchOptions } from "nitropack";
import type { PhaseDTO } from "~/src/season-cluster/infrastructure/DTO/02.PhaseDTO";
import type { Phase } from "~/src/season-cluster/domain/models/02.Phase";

interface UsePhases {
  getPhase: (phaseId: number) => Promise<Phase | undefined>;
}

export const usePhases = (): UsePhases => {
  return {
    getPhase,
  };

  async function getPhase(phaseId: number): Promise<Phase | undefined> {
    try {
      const { value: locale } = useCookie("lang");
      const opts: NitroFetchOptions<any> = { query: { lang: locale || "es" } };

      let path = `/api/v1/competition/phases/${phaseId}`;
      const response = await $fetch<PhaseDTO>(path, opts);

      if (response) {
        return response;
      } else {
        console.error("Fetched phase is null");
      }
    } catch (e) {
      console.error("Error fetching phase:", e);
    }
  }
};
